"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const log = async _ref => {
  let {
    message,
    type = "error"
  } = _ref;
  const {
    REACT_APP_PATH
  } = process.env;
  if (type === "warning") {
    type = "warn";
  }
  if (!message) {
    return "message missing";
  }
  let typeEnum = null;
  switch (type) {
    case "info":
      typeEnum = 1;
      break;
    case "warning":
    case "warn":
      typeEnum = 2;
      break;
    case "error":
    default:
      typeEnum = 3;
      break;
  }
  const response = await _axios.default.get("".concat(REACT_APP_PATH, "/log.api?type=").concat(typeEnum, "&message=").concat(message));
  const {
    data
  } = response;
  return data;
};
var _default = exports.default = log;